import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'src/app/core/utility.service';
import { Dashboard } from '../dashboard.models';

@Component({
  selector: 'app-top-chart',
  templateUrl: './top-chart.component.html',
  styleUrls: ['./top-chart.component.scss']
})
export class TopChartComponent implements OnInit {
  @Input('dashboardData') dashboardData: Dashboard;
  @Input('mainField') mainField: string;
  @Input('icon') icon: string;
  @Input('fields') fields: any[] = [];

  constructor(public utilityService: UtilityService) { }

  ngOnInit(): void {
  }

}
